"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _decorators = require("decorators");

var _class;

var Embed = (_class =
/*#__PURE__*/
function (_Activity) {
  babelHelpers.inherits(Embed, _Activity);

  function Embed() {
    babelHelpers.classCallCheck(this, Embed);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(Embed).apply(this, arguments));
  }

  babelHelpers.createClass(Embed, [{
    key: "setup",
    value: function setup(constraint, _ref) {
      var _this = this;

      var initial = _ref.initial;
      this._initialSize = initial;
      this._constraint = constraint;
      this.setupGlobalResize(".media-object img", constraint, initial);
      this.addEventListener('setupGlobalResize', this._embedGlobalResize);
      this.addEventListener('startActivityButtonClick', function () {
        return _this.startActivity();
      });
      this.addEventListener('startedActivity', this._embedStarted);
      this.addEventListener('timerExpired', function () {
        return _this.endActivity();
      });
      this.addEventListener('endedActivity', function () {
        return _this.activityComplete();
      });

      if (this.readOnly) {
        this.startActivity();
        this.activityComplete();
      }

      if (this._isEditing) {
        this.startActivity();
      }
    }
  }, {
    key: "_embedGlobalResize",
    value: function _embedGlobalResize(event) {
      var constraint = event.objectConstraint;
      this.$('.activity-body').toggleClass('container', constraint.mode == 'Column');
      this.$('.activity-body .media-object').toggleClass('col-xs-12', constraint.mode == 'Column');
    }
  }, {
    key: "_embedStarted",
    value: function _embedStarted(event) {
      this.showActivityTitle();
      this.$('.section-item.header-image').addClass('hidden');
      this.$('.section-item:not(.header-image)').removeClass('hidden');
      this.$('#iframe-embed-body').html(this.startActivityState.details.EmbeddedURL);
      this.setupGlobalResize('iframe, div.default-embed', this._constraint);

      if (!this.readOnly) {
        this.startTimer(event.activity.endTime ? new Date(event.activity.endTime).getTime() - new Date(event.activity.startTime).getTime() : 10000, true);
      }
    }
  }]);
  return Embed;
}(_base.default), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "_embedGlobalResize", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_embedGlobalResize"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "_embedStarted", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_embedStarted"), _class.prototype)), _class);
exports.default = Embed;